import axios from "axios";
import { LimitedListItemModel } from "models";
import { IAPIResult } from "models/interfaces";

export async function list() {
  // await Utils.sleep(300);
  const response = await axios.get<IAPIResult<LimitedListItemModel[]>>(
    "/api.d/v1/ec/limited-list/list"
  );
  return response.data;
}

export async function create(name: string, list: { corp_id: string }[]) {
  // await Utils.sleep(300);
  const data = {
    limited_list_name: name,
    limited_corp_list: list.map((v) => {
      return { limited_corp_id: v.corp_id };
    }),
  };
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/limited-list/create",
    data
  );
  return response.data;
}

export async function update(
  id: string,
  name: string,
  list: { corp_id: string }[]
) {
  // await Utils.sleep(300);
  const data = {
    limited_list_id: id,
    limited_list_name: name,
    limited_corp_list: list.map((v) => {
      return { limited_corp_id: v.corp_id };
    }),
  };
  const response = await axios.put<IAPIResult>(
    "/api.d/v1/ec/limited-list/update",
    data
  );
  return response.data;
}

export async function detail(id: string) {
  // await Utils.sleep(300);
  const response = await axios.get<IAPIResult<LimitedListItemModel>>(
    "/api.d/v1/ec/limited-list/detail",
    { params: { limited_list_id: id, limited_corp_name: "" } }
  );
  return response.data;
}

export async function del(id: string) {
  // await Utils.sleep(300);
  const response = await axios.delete<IAPIResult>(
    "/api.d/v1/ec/limited-list/delete",
    {
      data: {
        limited_list_id: id,
      },
    }
  );
  return response.data;
}
